import { useEffect, useState } from 'react';
import { getImageTonePalette } from '../utils/imageTone';

const DEFAULT_PALETTE = {
  tone: 'dark',
  textColor: '#ffffff',
  mutedColor: 'rgba(255,255,255,0.88)',
  accentColor: '#A89070',
  overlay: 'linear-gradient(90deg, rgba(15,20,24,0.72) 0%, rgba(15,20,24,0.45) 55%, rgba(15,20,24,0.2) 100%)',
  sectionOverlay: 'linear-gradient(180deg, rgba(15,20,24,0.82) 0%, rgba(15,20,24,0.48) 38%, rgba(15,20,24,0.22) 72%, rgba(15,20,24,0.1) 100%)',
  shadow: '0 2px 18px rgba(0,0,0,0.55)',
  btnPrimaryBg: '#ffffff',
  btnPrimaryText: '#384858',
  btnPrimaryBorder: '#ffffff',
  btnPrimaryHoverBg: '#A89070',
  btnPrimaryHoverText: '#ffffff',
  btnSecondaryBg: 'transparent',
  btnSecondaryText: '#ffffff',
  btnSecondaryBorder: 'rgba(255,255,255,0.9)',
  btnSecondaryHoverBg: '#ffffff',
  btnSecondaryHoverText: '#384858',
};

export function useAdaptiveImageTone(imageUrl) {
  const [palette, setPalette] = useState(DEFAULT_PALETTE);

  useEffect(() => {
    let active = true;
    getImageTonePalette(imageUrl).then((result) => {
      if (active) setPalette(result);
    });
    return () => {
      active = false;
    };
  }, [imageUrl]);

  return palette;
}

export default useAdaptiveImageTone;
